<h1 mat-dialog-title>
  {{ titleText | anessaTranslation: trigger }}
</h1>
<mat-dialog-content>
  <div *ngIf="resultsLoaded" class="fl results-dropdowns">
    <!-- Period Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          [(value)]="selectedPeriodType"
          placeholder="{{'RESULTS.GENERAL.SET_PERIOD' | anessaTranslation: trigger}}"
          disableOptionCentering
          (valueChange)="setTableData()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of periodCategories"
            [value]="opt.value">{{ opt.translationId }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Measurement System Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          [(value)]="selectedTechUnitType"
          placeholder="{{'RESULTS.GENERAL.SET_UNIT_TYPE' | anessaTranslation: trigger }}"
          disableOptionCentering
          (valueChange)="setTableData()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of techUnitTypes"
            [value]="opt.value">{{ opt.translationId }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Currency Select -->
    <div *ngIf="currencyUnitsLoaded" class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          [(value)]="selectedCurrency"
          [placeholder]="'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger"
          disableOptionCentering
          (valueChange)="setTableData()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of currencyUnits"
            [value]="opt">{{ opt.translationId | anessaTranslation: trigger }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <app-result-table
    *ngIf="showTable && tableData && tableData.length > 0"
    [tableData]="tableData"
    [tableHeaders]="tableHeaders"
    [isProjectInput]="true"
    [isEditable]="!resultsLoaded"
    [isResultsLoaded]="resultsLoaded">
  </app-result-table>
</mat-dialog-content>
<mat-dialog-actions>
  <mat-checkbox *ngIf="!resultsLoaded" class="validation-checkbox" [(ngModel)]="validationAccepted">
    {{ confirmText | anessaTranslation: trigger }}
  </mat-checkbox>
  <div class="action-buttons">
    <button
      mat-button
      class="btn-fat btn-red"
      type="button"
      (click)="onBackClick()">
      {{'PROJECT.COMMON.BACK' | anessaTranslation: trigger}}
    </button>
    <button
      *ngIf="!resultsLoaded"
      mat-button
      class="btn-fat btn-green"
      type="button"
      [disabled]="!validationAccepted || isSimulating"
      (click)="onNextClick()">
      {{'PROJECT.COMMON.NEXT' | anessaTranslation: trigger}}
    </button>
    <div [matTooltip]="this.limitToScreeningProjects() ?
            ('ACCOUNT.PERMISSIONS.ACCESS_LIMITED_TO_SCREENING_PROJECTS' | anessaTranslation: trigger) : null">
      <button
        *ngIf="showTable && resultsLoaded"
        mat-button
        class="btn-fat btn-green"
        type="button"
        [disabled]="limitToScreeningProjects()"
        (click)="onApproveClick()">
        {{'PROJECT.COMMON.APPROVE' | anessaTranslation: trigger}}
      </button>
    </div>
  </div>
</mat-dialog-actions>
